var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgIconSwapVerticalOutline(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-swap-vertical-outline_svg__ionicon",
    viewBox: "0 0 512 512"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    d: "M464 208L352 96 240 208m112-94.87V416M48 304l112 112 112-112m-112 94V96"
  })));
}
export default SvgIconSwapVerticalOutline;